export type ExternalVideoRecord = {
	__typename?: 'ExternalVideoRecord'
	video?: {
		__typename?: 'VideoField'
		thumbnailUrl: string
		title: string
		url: string
		height: any
	} | null
}

export enum MediaType {
	IMAGE = 'image',
	VIDEO = 'video',
}

export type MediaItem = {
	id: string | number
	src: string
	type: MediaType
	videoUrl?: string
	title?: string
}
